import { Component, EventEmitter, OnInit, Output, Input } from "@angular/core";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { calendarUtils } from "src/app/calendar/utils/convertDates.utils";

export interface IFilters {
  textSearch: string;
  startDate: string;
  endDate: string;
}

@Component({
  selector: "app-dc3-filters",
  templateUrl: "./dc3-filters.component.html",
  styleUrls: ["./dc3-filters.component.css"],
})
export class Dc3FiltersComponent implements OnInit {
  @Input() isLoading: boolean = false;
  @Output() filtersChange = new EventEmitter<IFilters>();

  // filtros
  public startDate: NgbDate | null = null;
  public endDate: NgbDate | null = null;
  public textSearch: string = "";

  // estado UI
  public showPlaceholder: boolean = true;
  public errorOccurred: boolean = false;

  ngOnInit(): void {
    // Filtros iniciales
    const today = new Date();
    this.startDate = new NgbDate(today.getFullYear(), 1, 1);
    this.endDate = new NgbDate(today.getFullYear(), 12, 31);
  }

  onSearchSubmit(): void {
    this.showPlaceholder = false;
    this.emitFilters();
  }

  // getter fecha inicio
  get getStartDateSelected() {
    return this.startDate
      ? calendarUtils.dateStructToDate(this.startDate)
      : null;
  }

  // getter fecha fin
  get getEndDateSelected() {
    return this.endDate ? calendarUtils.dateStructToDate(this.endDate) : null;
  }

  // validación fechas
  get getShowDatesError() {
    const start = this.getStartDateSelected;
    const end = this.getEndDateSelected;

    return !!(
      (start && !end) ||
      (end && !start) ||
      (start && end && start > end)
    );
  }

  // construir objeto de filtros
  get getFilters(): IFilters {
    return {
      textSearch: this.textSearch,
      startDate: this.getStartDateSelected
        ? calendarUtils.formatDateToYYYYMMDD(this.getStartDateSelected)
        : "",
      endDate: this.getEndDateSelected
        ? calendarUtils.formatDateToYYYYMMDD(this.getEndDateSelected)
        : "",
    };
  }

  // emitir filtros al main
  emitFilters() {
    if (this.getShowDatesError) {
      return;
    }
    if (!this.textSearch) {
      this.showPlaceholder = true;
    }

    this.filtersChange.emit(this.getFilters);
  }
  resetFilters() {
    this.textSearch = "";

    const today = new Date();

    this.startDate = new NgbDate(today.getFullYear(), 1, 1);
    this.endDate = new NgbDate(today.getFullYear(), 12, 31);

    this.showPlaceholder = true;
    this.errorOccurred = false;

    this.emitFilters();
  }
}
